import styled, { css } from 'styled-components'
import Tooltip from '../Tooltip'

interface ContainerProps {
  isFocused: boolean
  isFilled: boolean
  isErrored: boolean
  background?: string
  placeholdColor?: string
}

export const Container = styled.div<ContainerProps>`
  padding: 1rem;
  width: 100%;
  height: 43px;
  border-radius: 8px;
  border: solid 1px ${(props) => (props.color ? props.color : '#D0D5DD')};
  ${(props) =>
    props.background &&
    css`
      background: ${props.background} !important;
    `};

  ${(props) =>
    props.isErrored &&
    css`
      color: #c53030;
      border-color: #c53030;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: #ff6600;
      border-color: #ff6600;
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: #a7a7a7;
    `}

  display: flex;
  align-items: center;

  select {
    flex: 1;
    background: transparent;
    border: none;
    color: ${(props) => (props.placeholdColor ? props.placeholdColor : '#7a7a7a')};
    ::placeholder {
      color: ${(props) => (props.placeholdColor ? props.placeholdColor : '#D0D5DD')};
    }
    outline: none;
    &::-ms-expand {
      display: none;
    }
    :invalid {
      color: #c53030;
    }

    &:disabled {
      cursor: not-allowed;
    }
    option {
      color: #000;
    }
  }

  & + div {
    margin-top: 8px;
  }

  svg {
    margin-right: 16px;
  }
`

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`
